<button [disabled]="isLoading || disabled" appDisableAndShowText t type="button" class="btn {{btnClass}}" (click)="confirmClick.emit()">
    <span *ngIf="isLoading" style="color: inherit">
        <ui-spinner size="sm" class="me-1" color="light"></ui-spinner></span>{{text}}
</button>
